import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Container, Dimmer } from 'semantic-ui-react'
import Loader from '@ui/Loader'
import AllMode from './AllMode'
import StepMode from './StepMode'

@inject('surveyState')
@observer
export default class Steps extends Component {
  render() {
    const { surveyState, loading, onFinish, onNext } = this.props
    const { showAll } = surveyState

    return (
      <Dimmer.Dimmable as={Container} className='survey-main'>
        <Dimmer inverted active={loading}>
          <Loader />
        </Dimmer>
        {showAll ? <AllMode /> : <StepMode onFinish={onFinish} onNext={onNext} />}
      </Dimmer.Dimmable>
    )
  }
}
